import { render, staticRenderFns } from "./VersionSelect.vue?vue&type=template&id=5113742e&"
import script from "./VersionSelect.vue?vue&type=script&lang=js&"
export * from "./VersionSelect.vue?vue&type=script&lang=js&"
import style0 from "./VersionSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports